import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SvgIcons from '../../../../services/SvgIcons';
import strapiClient from '../../../../services/strapi/config';
import './PaymentConfirmation.scss';

const PaymentConfirmation = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [paymentStatus, setPaymentStatus] = useState({
        success: false,
        paymentId: null,
        orderNumber: null,
        formationAchetee: null,
        userInfo: localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')) : null,
        loading: true,
        error: null
    });

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const paymentIntent = params.get('payment_intent');
        const redirectStatus = params.get('redirect_status');

        if (redirectStatus === 'succeeded' && paymentIntent) {
            setPaymentStatus(prev => ({
                ...prev,
                success: true,
                paymentId: paymentIntent,
                loading: false
            }));

            // Récupérer le numéro de commande depuis Strapi
            // On attend 2s pour laisser le webhook terminer son traitement
            const fetchOrderNumber = async () => {
                for (let attempt = 0; attempt < 5; attempt++) {
                    try {
                        await new Promise(r => setTimeout(r, 2000));
                        const response = await strapiClient.get(
                            `/api/purchases/by-payment-intent/${paymentIntent}`
                        );
                        if (response.data?.numeroCommande) {
                            setPaymentStatus(prev => ({
                                ...prev,
                                orderNumber: response.data.numeroCommande,
                                formationAchetee: response.data.formationAchetee
                            }));
                            return;
                        }
                    } catch (e) {
                        // Pas encore créé, on réessaie
                    }
                }
            };
            fetchOrderNumber();
        } else {
            setPaymentStatus(prev => ({
                ...prev,
                success: false,
                loading: false,
                error: 'Le paiement a échoué ou a été annulé'
            }));
        }
    }, [location]);

    const cleanupAndNavigate = (path) => {
        localStorage.removeItem('payment_plan');
        localStorage.removeItem('user_info');
        localStorage.removeItem('workshop_info');
        navigate(path);
    };

    if (paymentStatus.loading) {
        return (
            <div className="payment-confirmation payment-confirmation--loading">
                <SvgIcons name="loading" width="64" height="64" color="#6D4F47" />
                <p>Finalisation de ta commande...</p>
            </div>
        );
    }

    if (!paymentStatus.success) {
        return (
            <div className="payment-confirmation payment-confirmation--error">
                <SvgIcons name="error" width="64" height="64" color="#ef4444" />
                <h1>Échec du paiement</h1>
                <p>{paymentStatus.error}</p>
                <div className="payment-confirmation__actions">
                    <button
                        onClick={() => {
                            try {
                                const workshopInfo = localStorage.getItem('workshop_info');
                                if (workshopInfo) {
                                    const info = JSON.parse(workshopInfo);
                                    if (info?.slug) { navigate(`/ateliers/${info.slug}`); return; }
                                    if (info?.id) { navigate(`/ateliers/${info.id}`); return; }
                                }
                            } catch (e) {}
                            navigate('/ateliers');
                        }}
                        className="payment-confirmation__button payment-confirmation__button--primary"
                    >
                        Réessayer
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="payment-confirmation payment-confirmation--success">
            <div className="payment-confirmation__icon">
                <SvgIcons name="check_circle" width="64" height="64" color="#22c55e" />
            </div>

            <h1>Paiement confirmé ! 🎉</h1>

            {paymentStatus.userInfo && (
                <div className="payment-confirmation__user-info">
                    <p>Merci <b>{paymentStatus.userInfo.firstName}</b> !</p>
                    <p>
                        Un email de confirmation a été envoyé à{' '}
                        <b>{paymentStatus.userInfo.email}</b>.
                    </p>
                </div>
            )}

            <div className="payment-confirmation__message">
                <p>
                    Si tu n'as pas encore de compte, tu recevras un email avec un lien
                    pour créer ton mot de passe et accéder à ta formation.
                </p>
                <p>
                    Si tu as déjà un compte, ta formation est disponible immédiatement
                    dans ton espace personnel.
                </p>
            </div>

            <div className="payment-confirmation__references">
                {paymentStatus.orderNumber ? (
                    <p className="payment-confirmation__reference">
                        <strong>Numéro de commande :</strong> {paymentStatus.orderNumber}
                    </p>
                ) : (
                    <p className="payment-confirmation__reference payment-confirmation__reference--loading">
                        Récupération du numéro de commande...
                    </p>
                )}
                {paymentStatus.paymentId && (
                    <p className="payment-confirmation__reference payment-confirmation__reference--stripe">
                        Référence de paiement : <span>{paymentStatus.paymentId}</span>
                    </p>
                )}
            </div>

            <div className="payment-confirmation__actions">
                <button
                    onClick={() => cleanupAndNavigate('/connexion')}
                    className="payment-confirmation__button payment-confirmation__button--primary"
                >
                    Accéder à mon espace
                </button>
                <button
                    onClick={() => cleanupAndNavigate('/')}
                    className="payment-confirmation__button payment-confirmation__button--secondary"
                >
                    Retour à l'accueil
                </button>
            </div>
        </div>
    );
};

export default PaymentConfirmation;
